export default __webpack_public_path__ + "static/media/export-customs-header.0193f70a.png";